
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/[slug]",
      function () {
        return require("private-next-pages/product/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/[slug]"])
      });
    }
  